import { render, staticRenderFns } from "./projectBox.vue?vue&type=template&id=9c8ce9c6&scoped=true&"
import script from "./projectBox.vue?vue&type=script&lang=js&"
export * from "./projectBox.vue?vue&type=script&lang=js&"
import style0 from "./projectBox.vue?vue&type=style&index=0&id=9c8ce9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8ce9c6",
  null
  
)

export default component.exports